import { IoAlertCircleOutline } from 'react-icons/io5'
import { formatBRL } from '@/lib/utils'

/** NFs ainda abertas: só nelas o valor pode (e deve) ser corrigido. */
const ABERTAS = ['rascunho', 'verificado']

/** Centavos de folga para não acusar diferença por arredondamento. */
const TOLERANCIA = 0.005

/**
 * A NF está aberta e com valor diferente do somatório dos serviços com fatura
 * ativa do contrato? Sem `valorContratado` (contrato sem serviço marcado para
 * fatura) ou com o valor em branco não há base de comparação.
 */
export function valorDivergente({ status, valor, valorContratado }) {
  if (!ABERTAS.includes(status)) return false
  if (valorContratado === null || valorContratado === undefined) return false
  if (valor === '' || valor === null || valor === undefined) return false

  const atual      = Number(valor)
  const contratado = Number(valorContratado)
  if (!Number.isFinite(atual) || !Number.isFinite(contratado)) return false

  return Math.abs(atual - contratado) > TOLERANCIA
}

/**
 * Indicador amarelo exibido ao lado do valor da NF quando ele diverge do
 * somatório dos serviços com fatura ativa do contrato (`aditivo_servico.fatura`,
 * considerando a linha mais recente de cada serviço). Igual ao alerta usado na
 * listagem de contratos. Ver docs/NF.md.
 */
export default function ValorDivergente({ status, valor, valorContratado, className = '' }) {
  if (!valorDivergente({ status, valor, valorContratado })) return null

  const titulo = `Valor diferente do contratado: os serviços faturáveis do contrato somam ${formatBRL(valorContratado)}.`

  return (
    <IoAlertCircleOutline
      className={`inline-block h-4 w-4 shrink-0 text-yellow-600 ${className}`}
      aria-label={titulo}
      title={titulo}
    />
  )
}
